import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

const MOBILE_MQ = "(max-width: 900px)";

function canUseLenis() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia(MOBILE_MQ).matches) return false;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
  return true;
}

export function useLenis() {
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    let lenis = null;
    let rafId = 0;

    const onScroll = () => {
      window.dispatchEvent(new Event("scroll"));
    };

    const start = () => {
      if (!canUseLenis() || lenis) return;
      lenis = new Lenis({
        duration: 1.3,
        smoothWheel: true,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
      lenisInstance = lenis;
      lenis.on("scroll", onScroll);

      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    };

    const stop = () => {
      cancelAnimationFrame(rafId);
      if (lenis) {
        lenis.off("scroll", onScroll);
        lenis.destroy();
        lenis = null;
        lenisInstance = null;
      }
    };

    const onMqChange = () => {
      stop();
      start();
    };

    start();
    mq.addEventListener("change", onMqChange);

    return () => {
      mq.removeEventListener("change", onMqChange);
      stop();
    };
  }, []);
}

export function scrollToSection(target) {
  const el = document.querySelector(target);
  if (!el) return;

  const navOffset = window.matchMedia(MOBILE_MQ).matches ? 72 : 90;

  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -navOffset, duration: 1.1 });
    return;
  }

  const top = el.getBoundingClientRect().top + window.scrollY - navOffset;
  window.scrollTo({ top, behavior: "smooth" });
}
